import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { User } from '../classes/user';
import { BaseService } from './base.service';
import { FilterShirt } from '../classes/filterCrest';

@Injectable({
    providedIn: 'root',
  })
  export class ShirtService extends BaseService{
    constructor(http: HttpClient){
        super(http);
        this.entity = 'crest';
    }

  private filterObs$: BehaviorSubject<FilterShirt> = new BehaviorSubject(new FilterShirt());
    getFilterObs(): Observable<FilterShirt> {
        return this.filterObs$.asObservable();
    }
    setFilterObs(filter: FilterShirt) {
          this.filterObs$.next(filter);
    }

  }